export const theme = {
  colors: {
    background: "rgba(218, 237, 255, 1)",
    bg_header: "rgba(6, 28, 70, 0.8)",
    bg_footer: "rgba(6, 33, 52, 1)",
    black: "rgba(17, 17, 17, 1)",
    bg_black: "rgba(40, 44, 52, 1)",
    gray: "#cccccc",
    gray_transparent: "rgb(204 204 204 / 50%)",
    white: "#FFFFFF",
    accent: "rgba(20, 104, 168, 1)",
    accent_link: "rgba(27, 153, 232, 1)",
    accent_btn: "rgba(26, 147, 239, 0.8)",
    accentHover: "rgba(20, 104, 168, 0.5)",
    accentHoverLink: "#3091EB",

    blue: "rgba(218, 237, 255, 1)",
    gradient: "linear-gradient(90deg, #FF634E 0%, #FFDF48 105.44%)",

    text: {
      primary: "rgba(17, 17, 17, 1)",
      secondary: "#111321",
      gray: "rgba(17, 17, 17, 0.6)",
    },
  },
  fontSizes: {
    xs: "12px",
    xss: "14px",
    xsss: "16px",
    s: "18px",
    m: "20px",
    ml: "22px",
    mll: "28px",
    l: "36px",
    xl: "45px",
    xxl: "64px",
  },
  fontWeights: {
    normal: 400,
    semibold: 500,
    bold: 700,
  },

  borders: {
    none: "none",
    normal: "2px solid",
  },
  shadows: {
    card: "7px 4px 14px rgba(49, 21, 4, 0.07)",
    modal: "7px 4px 14px rgba(0, 0, 0, 0.11)",
    time: "4px 4px 8px rgba(0, 0, 0, 0.25)",
    button: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  },
  fonts: {
    manrope: "Manrope, sans-serif",
  },

  device: {
    mobile: "(min-width: 320px)",
    tablet: "(min-width: 768px)",
    desktop: "(min-width: 1280px)",
  },

  transition: "0.2s all linear",
};
